export default __webpack_public_path__ + "static/media/whySmartApyImage.221e3245.png";